export default __webpack_public_path__ + "static/media/threebigcards_beauty_1.64a04ea9.png";